import React from "react";
import { Phone, ArrowRight, Clock, MapPin, ShieldCheck } from "lucide-react";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center pt-24 pb-16 overflow-hidden"
    >
      {/* Background image + overlays */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_mk-urgence-auto/artifacts/negsiuii_IMG_4353.jpg"
          alt="MK Remorquage en intervention à Perpignan"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/30" />
        <div className="absolute inset-0 grid-noise opacity-40" />
      </div>

      {/* Hazard stripe */}
      <div className="absolute top-20 left-0 right-0 h-2 hazard-stripes opacity-90" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-3xl animate-slide-up">
          {/* Live badge */}
          <div className="inline-flex items-center gap-2 bg-[#FFD600]/10 border border-[#FFD600]/40 px-4 py-2 rounded-full mb-6">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-[#FFD600] opacity-60 animate-ping" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#FFD600]" />
            </span>
            <span className="text-[#FFD600] text-xs font-bold uppercase tracking-[0.25em]">
              Disponible · Maintenant
            </span>
          </div>

          <h1
            className="font-display text-5xl sm:text-6xl lg:text-8xl text-white uppercase leading-[0.9] tracking-tight text-balance"
            data-testid="hero-title"
          >
            Remorquage Perpignan<br />
            <span className="text-[#FFD600]">24h/24, 7j/7.</span>
          </h1>

          <p className="mt-6 text-lg sm:text-xl text-neutral-300 max-w-xl leading-relaxed">
            <strong className="text-white">MK Remorquage</strong> — votre dépanneur à <strong className="text-white">Perpignan</strong> et dans tous les Pyrénées-Orientales.
            Remorquage, dépannage auto, gardiennage et récupération VHU.
            Intervention en <strong className="text-[#FFD600]">15 à 30 minutes</strong>.
          </p>

          {/* CTAs */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+33620735220"
              data-testid="hero-call-button"
              className="group inline-flex items-center justify-center gap-3 bg-[#FFD600] hover:bg-[#FACC15] text-[#0A0A0A] font-bold px-8 py-5 rounded-md uppercase tracking-wide text-base transition-all hover:scale-[1.02] glow-yellow"
            >
              <Phone className="w-5 h-5" strokeWidth={3} />
              Appeler · 06 20 73 52 20
            </a>
            <a
              href="#contact"
              data-testid="hero-contact-button"
              className="group inline-flex items-center justify-center gap-3 bg-white/5 hover:bg-white/10 border border-white/20 hover:border-[#FFD600]/50 text-white font-semibold px-8 py-5 rounded-md uppercase tracking-wide text-base transition-all"
            >
              Demander une intervention
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          {/* Trust strip */}
          <div className="mt-12 grid grid-cols-3 gap-4 sm:gap-8 max-w-2xl border-t border-white/10 pt-6">
            <div className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-[#FFD600] mt-1 shrink-0" strokeWidth={2.5} />
              <div>
                <div className="text-white font-bold text-sm sm:text-base">15-30 min</div>
                <div className="text-neutral-400 text-xs uppercase tracking-wider">Intervention</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-[#FFD600] mt-1 shrink-0" strokeWidth={2.5} />
              <div>
                <div className="text-white font-bold text-sm sm:text-base">Perpignan</div>
                <div className="text-neutral-400 text-xs uppercase tracking-wider">& alentours</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <ShieldCheck className="w-5 h-5 text-[#FFD600] mt-1 shrink-0" strokeWidth={2.5} />
              <div>
                <div className="text-white font-bold text-sm sm:text-base">3+ ans</div>
                <div className="text-neutral-400 text-xs uppercase tracking-wider">À mon compte</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
